import { cva, type VariantProps } from 'class-variance-authority';

export const tooltipCva = cva(
  [
    'absolute rounded-sm p-2 label-2xs font-normal shadow-md z-20',
    'max-w-[min(20rem,var(--ngp-tooltip-available-width,20rem))]',
    'origin-(--ngp-tooltip-transform-origin)',
    'data-enter:animate-scale-in',
    'data-exit:animate-scale-out',
  ],
  {
    variants: {
      variant: {
        dark: 'bg-neutral-900 text-white',
        light: 'bg-white text-neutral-900 border border-neutral-200',
      },
    },
    defaultVariants: {
      variant: 'dark',
    },
  },
);

export const arrowCva = cva(
  [
    'absolute size-3 rotate-45 border-neutral z-10',
    'data-[placement=top]:-bottom-1.5 data-[placement=top]:border-r data-[placement=top]:border-b',
    'data-[placement=bottom]:-top-1.5 data-[placement=bottom]:border-t data-[placement=bottom]:border-l',
    'data-[placement=left]:-right-1.5 data-[placement=left]:border-t data-[placement=left]:border-r',
    'data-[placement=right]:-left-1.5 data-[placement=right]:border-b data-[placement=right]:border-l',
  ],
  {
    variants: {
      variant: {
        dark: 'border-neutral-900 bg-neutral-900',
        light: 'border-neutral-200 bg-white',
      },
    },
    defaultVariants: {
      variant: 'dark',
    },
  },
);

export type TooltipCvas = VariantProps<typeof tooltipCva>;
